import React from 'react';
import './Opportunities.css';
import opportunitiesLogo from '../../../assets/Recruiter/recruiterOne.png'
import opportunitiesLogo2 from '../../../assets/Recruiter/recruiterTwo.png'
import opportunitiesLogo3 from '../../../assets/Recruiter/recruiterThree.png'
import opportunitiesLogo4 from '../../../assets/Recruiter/recruiterFour.png'
import opportunitiesLogo5 from '../../../assets/Recruiter/recruiterFive.png'
import opportunitiesLogo6 from '../../../assets/Recruiter/recruiterSix.png'
import opportunitiesLogo7 from '../../../assets/Recruiter/recruiterSeven.png'
import opportunitiesLogo8 from '../../../assets/Recruiter/recruiterEight.png'
import opportunitiesLogo9 from '../../../assets/Recruiter/recruiterNine.png'
import opportunitiesLogo10 from '../../../assets/Recruiter/recruiterTen.png'

function Opportunities() {
    return (
        <div className='opportunities-outer'>
            <div className="opportunites-inner ">
                <h2 className="header-text w-100 text-align-left">
                    Career Opportunities
                </h2>
                <div className="opportunities-logo container">
                    <div className="opportunities-box">
                        <img src={opportunitiesLogo} alt="" />
                    </div>
                    <div className="opportunities-box">
                        <img src={opportunitiesLogo2} alt="" />
                    </div>
                    <div className="opportunities-box">
                        <img src={opportunitiesLogo3} alt="" />
                    </div>
                    <div className="opportunities-box">
                        <img src={opportunitiesLogo4} alt="" />
                    </div>
                    <div className="opportunities-box">
                        <img src={opportunitiesLogo5} alt="" />
                    </div>
                    <div className="opportunities-box">
                        <img src={opportunitiesLogo6} alt="" />
                    </div>
                    <div className="opportunities-box">
                        <img src={opportunitiesLogo7} alt="" />
                    </div>
                    <div className="opportunities-box">
                        <img src={opportunitiesLogo8} alt="" />
                    </div>
                    <div className="opportunities-box">
                        <img src={opportunitiesLogo9} alt="" />
                    </div>
                    <div className="opportunities-box">
                        <img src={opportunitiesLogo10} alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Opportunities
